import { useState, useEffect } from 'react'
import appStoreIcon from 'assets/icons/en-gb/appStore.svg'
import googlePlayIcon from 'assets/icons/en-gb/googlePlay.svg'
import { links } from 'data/links'
import { isIOS, isMacOs } from 'react-device-detect'

export function useMobileStore() {
  const [mobileStore, setMobileStore] = useState({
    icon: googlePlayIcon,
    link: links.googlePlay,
  })

  useEffect(() => {
    if (isIOS || isMacOs) {
      setMobileStore({
        icon: appStoreIcon,
        link: links.appStore,
      })
    }
  }, [])

  return {
    mobileStoreIcon: mobileStore.icon,
    mobileStoreLink: mobileStore.link,
  }
}
